import EServiceEngineerActions from '@r1-frontend/service-engineer-visit/constants/actions';
import { IAction } from '@r1-frontend/service-engineer-visit/reducer/reducer';

const flushHour = (): IAction<EServiceEngineerActions.FLUSH_HOUR, null> => ({
    type: EServiceEngineerActions.FLUSH_HOUR,
    payload: null,
});

export default flushHour;
